module.exports = __webpack_public_path__ + "static/logo-b7b84f1f6f9e7c54f2af8b410e665ffd.png";